<script>
import { Pie, mixins } from "vue-chartjs";
import Chart from "chart.js";

Chart.defaults.global.legend.labels.usePointStyle = true;

const { reactiveProp } = mixins;

const supportedCallbackGenerator = {
  title(cfg) {
    if (cfg) {
      return function(tooltipItem, data) {
        const prefix = cfg.prefix ?? "";
        const subfix = cfg.subfix ?? "";

        return `${prefix}: ${
          data["labels"][tooltipItem[0]["index"]]
        } ${subfix}`;
      };
    }
  },
  label(cfg) {
    // Label is percent
    if (cfg) {
      return function(tooltipItem, data) {
        const prefix = cfg.prefix ?? "";
        const subfix = cfg.subfix ?? "";

        const arrData = data["datasets"][0]["data"];

        const total = arrData.reduce((total, curVal) => total + curVal, 0);
        const percent = ((arrData[tooltipItem["index"]] / total) * 100).toFixed(
          2
        );
        return `${prefix} ${percent} % ${subfix}`;
      };
    }
  },
  afterLabel(cfg) {
    if (cfg) {
      return function(tooltipItem, data) {
        const prefix = cfg.prefix ?? "";
        const subfix = cfg.subfix ?? "";

        return `${prefix} ${
          data["datasets"][0]["data"][tooltipItem["index"]]
        } ${subfix}`;
      };
    }
  }
};

export default {
  extends: Pie,
  props: ["tooltipsCallbackCfg", "legendClassNames"],
  mixins: [reactiveProp],
  data() {
    const toolTipsCallbacks = this.generateTooltipsCb();
    const lgItemClassName = this.legendClassNames.itemContainer;
    const lgLabelClassName = this.legendClassNames.label;

    return {
      options: {
        tooltips: {
          callbacks: toolTipsCallbacks,
          backgroundColor: "#FFF",
          titleFontSize: 16,
          titleFontColor: "#00072B",
          bodyFontColor: "#000",
          bodyFontSize: 14,
          displayColors: false
        },
        legend: {
          display: false
        },
        legendCallback: chart => {
          const labels = chart.data.labels;
          const firstDataSet = chart.data.datasets[0];
          const bgColors = firstDataSet?.backgroundColor;

          const legendsHtml = firstDataSet.data.reduce(
            (legendItemsHtml, _, idx) => {
              return legendItemsHtml.concat([
                `<li class="${lgItemClassName}">
                  <span class="icon" style="background-color:${bgColors[idx]}"></span>
                  <span class="${lgLabelClassName}">${labels[idx]}</span>
                </li>
              `
              ]);
            },
            []
          );

          return `<ul id="${chart.id}" class="flex flex-wrap justify-center">
                    ${legendsHtml.join("")}
                  </ul>`;
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
    const legendsHtml = this.$data._chart.generateLegend();
    this.$emit("generated-legends-html", legendsHtml);
  },
  methods: {
    generateTooltipsCb() {
      if (this.tooltipsCallbackCfg) {
        return Object.entries(this.tooltipsCallbackCfg).reduce(
          (callbackCfg, [cfgKey, cfgValue]) => {
            if (supportedCallbackGenerator[cfgKey]) {
              callbackCfg[cfgKey] = supportedCallbackGenerator[cfgKey](
                cfgValue
              );
            }

            return callbackCfg;
          },
          {}
        );
      }

      return {};
    }
  },
  watch: {
    chartData() {
      // TODO - FIX ME: Can optimize me by just call me when labels is changed
      const legendsHtml = this.$data._chart.generateLegend();
      this.$emit("generated-legends-html", legendsHtml);
    }
  }
};
</script>

<style lang="scss"></style>
